import styled from 'styled-components'

export interface IProps {
  width?: string | number
  bgColor?: string
}

export const SecondaryLoadingAnimation = ({ width = 50, bgColor }: IProps) => {
  return (
    <Spinner width={width} bgColor={bgColor} data-test="loadingAnimation">
      <span />
      <span />
      <span />
    </Spinner>
  )
}

const Spinner = styled.span<IProps>`
  width: ${({ width }) => width}px;
  text-align: center;

  & > span {
    width: ${({ width }) => (width ? Math.floor(+width / 3.88) : 18)}px;
    height: ${({ width }) => (width ? Math.floor(+width / 3.88) : 18)}px;
    background-color: ${({ bgColor }) => bgColor || '#5E72E4'};

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  & span:nth-child(1) {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  & span:nth-child(2) {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
`
